<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-2">
                    <div class="btn-group enrollment-list-btn-info" role="group">
                      <button type="button" class="btn"
                      [ngClass]="{'btn-primary':activeTab=='Placement','btn-outline-primary':activeTab!='Placement'}"
                      (click)="activeReportsTab(activeTab=='Placement'?'':'Placement')">Placed</button>
                      <button type="button" class="btn"
                        [ngClass]="{'btn-primary':activeTab=='Performer','btn-outline-primary':activeTab!='Performer'}"
                        (click)="activeReportsTab(activeTab=='Performer'?'':'Performer')">Performer</button>
                    </div>
                </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-2">
                    <!-- <div class="btn-group enrollment-list-btn-info" role="group">
                      <button type="button" *ngFor="let status of statusList" class="btn"
                          [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                          (click)="activeEnrollmentTab(status?.name)">{{status.displayname}}</button>
                    </div> -->
                    <div>
                      <button *ngIf="guideline_data[0]" class="btn btn-outline-primary" (click)="createDynamicComponent(guideline_data[0])">Placements Guideline</button>
                    </div>
                  </div>
                  <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" #name />
                        <button class="btn search-btn glow position-absolute">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0">
                          Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/jobs/add" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
  
                    </div>
                  </div> -->
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                    [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                    [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber">
                      <ngx-datatable-footer>
                        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize">
                          <div class="datatable-footer-inner">
                            <div class="total-count">
                              <span>
                                <span *ngIf="activeTab=='Placement'"><span
                                    id="hot-color" *ngIf="activeTab=='Placement'">Placed : {{page.totalPages}}</span>
                                </span>
                                <span *ngIf="activeTab=='Performer'"><span
                                  id="hot-color" *ngIf="activeTab=='Performer'">Performer : {{page.totalPages}}</span>
                              </span>
                              </span>
                            </div>
                          </div>
                        </ng-template>
                      </ngx-datatable-footer>
                    </ngx-datatable>
                  </div>
                </div>
              </fieldset>
              <!-- <fieldset class="form-group">
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                      <label
                        >Show
                        <select
                          name="users-list-select"
                          class="form-control form-control-sm d-inline-block width-100 p-right-25 pl-4 mx-1"
                          (click)="updateLimit($event)"
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option Selected value="100">100</option>
                        </select>
                        entries</label>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                      <div class="row-flex">
                        <div class="col-flex-2 mb-1">
                          <label for="ngx-filter-ref"
                            >Search:
                            <input
                              id="ngx-filter-ref"
                              class="form-control form-control-sm d-inline-block width-200 ml-1"
                              type="text"
                              (keyup)="getContactFilter($event)"
                            />
                          </label>
                        </div>                    
                        <div class="col-flex-2 mb-1"  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                          <button
                            type="reset"
                            class="btn btn-primary btn-block users-list-clear glow mb-0"
                            routerLink="/jobs/add"
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset> -->
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
                >
                <ngx-datatable-column name="Name" prop="name" [width]="180">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                        <img class="rounded-circle mr-1 avatar" *ngIf="row.image" [src]="imageUrl + row.image" height="42"
                          width="42" />
                        <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                          <div class="avatar-content">{{ row?.name | shortName }}</div>
                        </div>
                         <!-- --------- card ------------------------------------ -->
                         <div class="card-overlay-on-hover" *ngIf="activeTab=='Placement'">
                          <div class="card">
                            <div class="card-content">
                              <div class="card-img">
                                <img *ngIf="row?.user_id?.image" class="card-img-top img-fluid" [src]="imageUrl + row?.user_id?.image"
                                  alt="Card image cap">
                                <div *ngIf="!row?.user_id?.image" class="avatarImg mr-1 ml-0 bg-primary">
                                  <div class="avatar-contentImg">{{ row?.name | shortName }}</div>
                                </div>
                              </div>
                              <div class="card-body p-0">
                                <h4>{{row?.name}}</h4>
                                <p>{{row?.email}}</p>
                                <p>{{row?.phone}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      <!-- ---------------------------------------------------------- -->
    
                        <!-- <div class="cell-line-height">
                          <a class="line-height-1 mb-0">{{ row.categoryName }}</a>
                        </div> -->
                        <div class="cell-line-height">
                          <p *ngIf="activeTab=='Performer'" class="font-medium-1 line-height-1 mb-0 cursor-pointer">
                            {{ row.name }}<span style="position: absolute;" *ngIf="row?.isperformer=='yes'"><img src="assets/tick-parple-clr.svg" alt=""></span>
                          </p>
                          <p *ngIf="activeTab=='Placement'" class="font-medium-1 line-height-1 mb-0 cursor-pointer" placement="right" [ngbTooltip]="'Bio : '+row?.bio" >
                            {{ row.name }}<span style="position: absolute;" *ngIf="row?.isperformer=='yes'"><img src="assets/tick-parple-clr.svg" alt=""></span>
                          </p>
                         
                          <!-- <span class="text-muted font-small-2">
                            Nuclear Power Engineer</span
                          > -->
                        </div>
                      </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column *ngIf="activeTab=='Performer'" name="Email" prop="email" [width]="100"></ngx-datatable-column>
                <ngx-datatable-column *ngIf="activeTab=='Performer'" name="Phone" prop="phone" [width]="80"></ngx-datatable-column>
                <ngx-datatable-column *ngIf="activeTab=='Placement'" name="Company" prop="placement_business" [width]="100">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <p placement="right" [ngbTooltip]="'placement-info : '+row?.placementinfo">
                      {{row?.placement_business?.name}}
                    </p>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column *ngIf="activeTab=='Placement'" name="Placement Info" prop="placementinfo" [width]="300">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    {{row?.placementinfo}}
                  </ng-template>
                </ngx-datatable-column> -->
                <ngx-datatable-column name="LinkedIn" prop="linkedIn" [width]="40">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <a [href]="row.linkedIn" target="_blank" *ngIf="isValidLinkedIn(row.linkedIn)">
                      <i class="ft-linkedin text-primary cursor-pointer mr-2" placement="right"
                    [ngbTooltip]="row.linkedIn"></i>
                    </a>
                  </ng-template>
                </ngx-datatable-column>

  
                <ngx-datatable-column name="Actions" [width]="50">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i class="ft-trash-2 cursor-pointer danger"
                      (click)="updateStudent(row.id)"></i>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>
  <div #dynamicContainer></div>
